import { colors } from '@atlaskit/theme';
import { WEEKS_IN_REPORT } from '../../../common/constants';
import type {
	BarChartDataPoint,
	Count,
	DeploymentFrequencyReportWeekData,
	DeploymentFrequencyReportWithProviderInfo,
} from '../../../common/types';
import { isProdDataEmpty as checkIsProdDataEmpty } from '../../../services/deployment-frequency-core/utils';

const getEmphasisColor = (prodDeploymentsCount: Count, wholePeriodStatistic: Count): string =>
	prodDeploymentsCount >= wholePeriodStatistic ? colors.G300 : colors.Y300;

export const convertReportCoreToChartDataPoints = (
	deploymentFrequencyReportData: DeploymentFrequencyReportWithProviderInfo,
	selectedStartDateInclusive: Date,
): BarChartDataPoint[] => {
	const isProdDataEmpty = checkIsProdDataEmpty(deploymentFrequencyReportData);

	return deploymentFrequencyReportData.weeksData.map(
		(weekData: DeploymentFrequencyReportWeekData, i: number) => {
			const prodDeploymentsCount = weekData.deploymentCount.prod;
			const isSelectedData =
				!isProdDataEmpty &&
				selectedStartDateInclusive.getTime() === weekData.startDateInclusive.getTime();
			const emphasisColor = getEmphasisColor(
				prodDeploymentsCount,
				deploymentFrequencyReportData.averageDeploymentCount,
			);
			const isCurrentWeekData = i === WEEKS_IN_REPORT - 1;
			const isCurrentWeekEmpty = prodDeploymentsCount === 0;
			const barColor = isCurrentWeekData ? colors.N60 : colors.N100;

			return {
				value: prodDeploymentsCount,
				itemStyle: {
					color: isSelectedData ? emphasisColor : barColor,
					borderType: isCurrentWeekData && !isCurrentWeekEmpty ? 'dashed' : undefined,
					borderColor: isCurrentWeekData && !isCurrentWeekEmpty ? colors.N300 : undefined,
				},
				emphasis: {
					itemStyle: {
						color: emphasisColor,
					},
				},
				customInfo: {
					startDateInclusive: weekData.startDateInclusive,
					medianIssuesPerDeployment: weekData.medianIssuesPerDeployment.prod,
					// This will be used for x-axis label color
					emphasisColor: isSelectedData ? emphasisColor : null,
				},
			};
		},
	);
};
